import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    connect() {
        $(this.element).slideDown(1000);
    }
}
